<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<template>
  <div class="page-used-style development">
    <p>加载中...</p>
    <!-- <p>开发中, 敬请期待...</p> -->
  </div>
</template>

<style lang="scss" scoped>
.development {
  background: url('~imgs/view-bg.webp') no-repeat center;
  background-size: 100%;
  display: grid;
  place-items: center;
  font-size: 32px;
}
</style>
